import { createContext, useContext, useState } from 'react';

const CheckoutContext = createContext({
  shippingAddress: {},
  setShippingAddress: () => {},
  billingAddress: {},
  setBillingAddress: () => {},
  addressValidationResponse: null,
  setAddressValidationResponse: () => {},
  addressValidationStatus: null,
  setAddressValidationStatus: () => {},
  addressClient: null,
  checkoutClient: null,
  orderData: {},
  orderRefresh: () => {},
  setToast: () => {},
  payWithSavedCard: false,
  setPayWithSavedCard: () => {},
  makeDefaultCard: false,
  setMakeDefaultCard: () => {},
});

/*
  Custom hook to use checkout flow utils
 */
const useCheckoutFlow = () => {
  return useContext(CheckoutContext);
};

/*
  Provides a component that wraps your app with
  clients and utils to complete checkout
 */
const CheckoutFlow = ({
  addressClient,
  checkoutClient,
  orderData,
  orderRefresh,
  setToast,
  children,
}) => {
  const [shippingAddress, setShippingAddress] = useState(
    orderData.shipping_address,
  );
  const [billingAddress, setBillingAddress] = useState(
    orderData.billing_address,
  );
  const [addressValidationResponse, setAddressValidationResponse] =
    useState(null);
  const [addressValidationStatus, setAddressValidationStatus] = useState(null);
  const [payWithSavedCard, setPayWithSavedCard] = useState(false);
  const [makeDefaultCard, setMakeDefaultCard] = useState(false);

  return (
    <CheckoutContext.Provider
      value={{
        shippingAddress,
        setShippingAddress,
        billingAddress,
        setBillingAddress,
        addressValidationResponse,
        setAddressValidationResponse,
        addressValidationStatus,
        setAddressValidationStatus,
        addressClient,
        checkoutClient,
        orderData,
        orderRefresh,
        setToast,
        payWithSavedCard,
        setPayWithSavedCard,
        makeDefaultCard,
        setMakeDefaultCard,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export { CheckoutFlow, useCheckoutFlow };
